// PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PrivateRoute = ({ children, requiredRole }) => {
  const { currentUser, isAdmin, isSuperAdmin, loading } = useAuth();

  if (loading) {
    // Optionally render a loading indicator
    return <div>Loading authentication...</div>;
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole === "superadmin" && !isSuperAdmin) {
    return <Navigate to="/" replace />;
  }

  if (requiredRole === "admin" && !(isAdmin || isSuperAdmin)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateRoute;
